module.exports = __webpack_public_path__ + "static/media/traviar_eletrostatico_CORE_E_DISCO.123cd80f.png";